import { useApi } from '@gik/core/api/swr/useApi';

export function useVisaUnallowedWords() {
  return useApi<string[]>('bad-words');
}
